const Placeholders = {
  OrganisationLogo:
    'https://via.placeholder.com/206.png/111B32/F9F9F9?text=No+Logo',
  OrganisationLogoSmall:
    'https://via.placeholder.com/26.png/111B32/F9F9F9?text=NA',
};

export default Placeholders;
